import { CircularLoader } from "@duosoftbg/nacid-components";
import React, { useEffect } from "react";
import { useState } from "react";
import { QFTableHorizontal } from "./QFTableHorizontal";
import { QFTableVertical } from "./QFTableVertical";
import { CountryQF } from "../../../types/QFDataTypes";

export const QFTables = ({ data }) => {
  const [activeTable, setActiveTable] = useState<"V" | "H">("H");
  const [logicalTableMapH, setLogicalTableMapH] = useState<boolean[][]>(
    Array(3)
      .fill(null)
      .map(() => Array(5).fill(false)),
  );
  const [columnSwitchH, setColumnSwitchH] = useState<boolean[]>(Array(5).fill(false));
  const [rowSwitchH, setRowSwitchH] = useState<boolean[]>([]);

  const [activeLevelV, setActiveLevelV] = useState<number>(6);
  const [hideMainHeaderV, setHideMainHeaderV] = useState<boolean[]>(Array(2).fill(false));
  const [hideSideHeaderV, setHideSideHeaderV] = useState<boolean[]>(Array(2).fill(false));

  const windowSize = useWindowSize().width;

  const handleTables = (table: "V" | "H") => {
    setActiveTable(table);
  };

  useEffect(() => {
    setRowSwitchH((prev) =>
      prev.map((_, r) => {
        const row = logicalTableMapH[r];
        if (row.every(Boolean)) return true;
        if (!row.includes(true)) return false;
        return prev[r];
      }),
    );
    setColumnSwitchH((prev) =>
      prev.map((_, c) => {
        const columnValues = logicalTableMapH.map((row) => row[c]);
        if (columnValues.every(Boolean)) return true;
        if (!columnValues.includes(true)) return false;
        return prev[c]; // mixed -> keep previous
      }),
    );
  }, [logicalTableMapH]);

  useEffect(() => {
    if (data?.countriesQF) {
      setRowSwitchH(Array(data.countriesQF.length).fill(false));
      setLogicalTableMapH(Array.from({ length: data.countriesQF.length }, () => Array(5).fill(false)));
      // @ts-ignore
      setActiveTable(windowSize > 1024 ? "H" : "V");
      const minLevel: number = data?.countriesQF.reduce((curr: CountryQF, min: number) =>
        curr.level < min ? curr.level : min,
      ).level;
      setActiveLevelV(minLevel);
    }
  }, [data]);

  if (data === null) {
    return <CircularLoader mt={20} />;
  }

  return (
    <>
      {data &&
        (activeTable === "H" ? (
          <QFTableHorizontal
            countryData={data}
            handleTables={handleTables}
            setLogicalTableMapH={setLogicalTableMapH}
            setColumnSwitchH={setColumnSwitchH}
            setRowSwitchH={setRowSwitchH}
            logicalTableMapH={logicalTableMapH}
            columnSwitchH={columnSwitchH}
            rowSwitchH={rowSwitchH}
          />
        ) : (
          <QFTableVertical
            countryData={data}
            handleTables={handleTables}
            setActiveLevelV={setActiveLevelV}
            setHideMainHeaderV={setHideMainHeaderV}
            setHideSideHeaderV={setHideSideHeaderV}
            activeLevelV={activeLevelV}
            hideMainHeaderV={hideMainHeaderV}
            hideSideHeaderV={hideSideHeaderV}
          />
        ))}
    </>
  );
};

const useWindowSize = () => {
  const [size, setSize] = useState({ width: window.innerWidth, height: window.innerHeight });

  useEffect(() => {
    const handleResize = () => {
      setSize({ width: window.innerWidth, height: window.innerHeight });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return size;
};
